import { useMemo } from "react";

import { TypeOutline } from "lucide-react";
import { DefaultTooltip, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui";

import { useCraftProp } from "../utils";

import ColorPicker from "./Color";

export default function TextColorProperty() {
  const { value: clip, setValue: setClip } = useCraftProp('background.clip')
  const { setValue: setTextColor } = useCraftProp('textColor')

  const isClipText = useMemo(() => clip === 'bg-clip-text', [clip])

  const handleChangeClipText = checked => {
    setTextColor(checked ? 'transparent' : '')
    setClip(checked ? 'bg-clip-text' : '')
  }

  return <>
    <div className='flex gap-1 items-center'>
      <ColorPicker key='color' name='textColor' disabled={isClipText} />
      <ToggleOptionGroup value={isClipText ? 'clip' : ''} type='single' onValueChange={value => handleChangeClipText(value === 'clip')}>
        <ToggleOptionGroupItem value='clip'>
          <DefaultTooltip content='Clip text' triggerProps={{ className: 'w-full flex justify-center' }}>
            <TypeOutline size='16' />
          </DefaultTooltip>
        </ToggleOptionGroupItem>
      </ToggleOptionGroup>
    </div>
  </>
}
